import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Footer from "@/components/Footer";

export default function Privacy() {
  const lastUpdated = "May 7, 2026";

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 max-w-4xl mx-auto px-6 py-20 lg:py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="eyebrow text-muted-foreground mb-4 text-center">Legal · Inkspot</div>
          <h1 className="font-serif text-5xl sm:text-7xl font-black tracking-tight text-center mb-8">
            Privacy Policy.
          </h1>
          <div className="text-center text-sm text-muted-foreground mb-16 italic">
            Last updated: {lastUpdated}
          </div>

          <div className="prose prose-neutral dark:prose-invert max-w-none space-y-12 text-foreground/90">
            <section>
              <h2 className="font-serif text-3xl font-bold tracking-tight mb-4 border-b border-border pb-2">1. The Principle</h2>
              <p className="leading-relaxed">
                Inkspot is built for writers and readers. Our business model is not based on selling your data. 
                We collect only what is necessary to provide you with a high-quality publishing experience and 
                to keep the community safe and functional.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-bold tracking-tight mb-4 border-b border-border pb-2">2. Data We Collect</h2>
              <div className="space-y-4">
                <p><strong>Account Information:</strong> When you register, we collect your email, username, and password (hashed). If you use Google Login, we receive your name, email, and profile picture from Google.</p>
                <p><strong>Content:</strong> We store the articles, images, comments, and profile information you voluntarily publish on the platform.</p>
                <p><strong>Usage Data:</strong> We track basic metrics like view counts, likes, and bookmarks to provide analytics to authors and to power our discovery features.</p>
              </div>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-bold tracking-tight mb-4 border-b border-border pb-2">3. How We Use Data</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>To provide, maintain, and improve our services.</li>
                <li>To allow authors to see how their work is performing.</li>
                <li>To personalize your experience on the platform (e.g., following your favorite authors).</li>
                <li>To communicate with you about your account or service updates.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-bold tracking-tight mb-4 border-b border-border pb-2">4. Your Control</h2>
              <p className="leading-relaxed">
                You own your content. You can edit or delete your articles at any time from your dashboard. 
                If you wish to delete your entire account and all associated data, you can do so from your settings 
                or by contacting our support team.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-bold tracking-tight mb-4 border-b border-border pb-2">5. Cookies</h2>
              <p className="leading-relaxed">
                We use essential cookies to keep you signed in. We do not use third-party tracking cookies 
                for advertising purposes.
              </p>
            </section>

            <section className="bg-card border border-border p-8 mt-20">
              <h2 className="font-serif text-2xl font-bold mb-4">Questions?</h2>
              <p className="text-sm text-muted-foreground mb-6">
                If you have any questions about this Privacy Policy, please reach out to us.
              </p>
              <Link to="/about" className="link-underline text-foreground font-medium">Contact Support</Link>
            </section>
          </div>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
}
